import { Logger } from '@west-australian-newspapers/typescript-log'
import { loadRrmeBreachPackagesFromApi } from './common'

export interface InitSubscriptionOffersOptions {
    offerGroup?: string
    variant?: string
}

export async function initSubscriptionOffers(
    publicationId: string,
    log: Logger,
    { offerGroup = 'breach', variant }: InitSubscriptionOffersOptions = {},
) {
    return loadRrmeBreachPackagesFromApi(
        publicationId,
        log,
        offerGroup,
        variant,
    )
}
